import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../layout/common/authLayout";
import { CustomPassword } from "../../shared/components/allInput";
import CustomButton from "shared/components/inputButton";
import formValidation from "utils/validations";
import { useDispatch } from "react-redux";
import { resetPasswordAction } from "store/actions/AuthActions";
import { showFormErrors } from "utils/CommonFunctions";

export default function ResetPassword({ email }) {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  if (!email) navigate("/");
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    email: email,
    password: "",
    confirmPassword: ""
  })

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data)
    setData((prev) => ({ ...prev, [name]: value, formErrors }))
  }

  const onSubmit = () => {
    if (showFormErrors(data, setData)) {
      delete data.confirmPassword; //remove unwanted field from api payload
      dispatch(resetPasswordAction(data, setLoading, dispatch, navigate))
    }
  };

  return (
    <>
      {/* <Layout
      title="Change Your Password"
       description="Make sure both fields match before saving your changes."
     > */}
      <h2 className={`text-2xl md:text-4xl text-left py-1 mb-2`}>
        Change Your Password
      </h2>
      <p className="text-lg text-left">Make sure both fields match before saving your changes.</p>
      <form className="mt-5 pt-2">
        <CustomPassword
          name="password"
          data={data}
          onChange={handleChange}
        />
        <CustomPassword
          name="confirmPassword"
          data={data}
          onChange={handleChange}
        />
        <CustomButton label="Continue" extraClassName="mb-5 mt-2 w-full" type="button" onClick={onSubmit} loading={loading} />
        <p className="mt-2 text-center">
          Or go back to the{" "}
          <Link to="/" className="underline color-black">
            login page.
          </Link>
        </p>
      </form>
      {/* </Layout> */}
    </>
  );
}
